import React from "react";
import { Routes, Route } from "react-router-dom";

import "./css/App.css";

import Home from "./pages/Home";
import Community from "./pages/Community";
import Roote from "./pages/Roote";
import Support from "./pages/Support";
import Contact from "./pages/Contact";
import Signup from "./auth/Signup";
import BoardList from "./board/BoardList";
import BoardDetail from "./board/BoardDetail";
import BoardForm from "./board/BoardForm";
import Login from "./auth/Login";
import Dashboard from "./auth/Dashboard";
import QnAboard from "./pages/QnAboard";
import Footer from "./pages/Footer";
import Header from "./pages/Header";
import Affiliate from "./pages/Affiliate";
import ForgotId from "./auth/ForgotId";
import ResetPasswordRequest from "./auth/ResetPasswordRequest";
import ResetPassword from "./auth/ResetPassword";
import JobBoardList from "./jobboard/JobBoardList";
import JobPostings from "./jobboard/JobPostings ";
import JobSeekers from "./jobboard/JobSeekers";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/Header" element={<Header />} />
        <Route path="/" element={<Home />} />
        <Route path="/community" element={<Community />} />
        <Route path="/roote" element={<Roote />} />
        <Route path="/support" element={<Support />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/board" element={<BoardList />} />
        <Route path="/board/new" element={<BoardForm />} />
        <Route path="/board/:id" element={<BoardDetail />} />
        <Route path="/board/edit/:id" element={<BoardForm />} />
        <Route path="/QnAboard" element={<QnAboard />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Footer" element={<Footer />} />
        <Route path="/Affiliate" element={<Affiliate />} />
        <Route path="/ForgotId" element={<ForgotId />} />
        <Route
          path="/ResetPasswordRequest"
          element={<ResetPasswordRequest />}
        />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/JobBoardList" element={<JobBoardList />} />
        <Route path="/jobpostings" element={<JobPostings />} />
        <Route path="/jobseekers" element={<JobSeekers />} />
      </Routes>
    </div>
  );
}

export default App;
